export default {"src":"/_next/static/media/close.7cba57f0.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};